import React from 'react'

import { hideSidebar } from '../actions/uiActions'
import { NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'

function Navlink({ title = 'Soy un titulo', link = 'dashboard', icon }) {
  const dispatch = useDispatch()

  const size = () => {
    if (window.screen.width <= 768) dispatch(hideSidebar())
  }

  return (
    <NavLink
      className={({ isActive }) =>
        isActive
          ? 'p-3 rounded-md bg-gray-dark transition-all  duration-300 ease-in-out flex items-center'
          : 'p-3 rounded-md hover:bg-gray-dark transition duration-300 ease-in-out flex items-center'
      }
      to={link}
      onClick={size}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {title}
    </NavLink>
  )
}

export default Navlink
